'use client'

import React from 'react'
import { Box } from '@hanzo/ui'

import { ApplyTypography, Button } from '@hanzo/ui/primitives'
import { useIam } from '@hanzo/iam/react'

import { AccessCodeInput, Footer, Main } from '@luxfi/ui'

import siteDef from '../site-def'

const Home = () => {
  const { isAuthenticated, login } = useIam()

  return (<>
    <Main className='h-screen -mt-11 md:-mt-12'>
      <ApplyTypography className='flex flex-col gap-8 m-auto text-center'>
        <h1>MEMBER LOGIN</h1>
        {isAuthenticated ? (
          <Box className='flex flex-col gap-4 max-w-[40rem] mx-auto'>
            <h5>If you are an existing Lux member accessing this website for the first time, please enter your invite code.</h5>
            <AccessCodeInput />
          </Box>
        ) : (
            /* The password is typed on lux.id, never on this page: sign-in is the
              authorization-code + PKCE redirect, and /auth/callback redeems the
              code it brings back. */
          <Button
            variant='primary'
            className='w-full max-w-[20rem] mx-auto'
            onClick={() => { void login() }}
          >
            Login
          </Button>
        )}
      </ApplyTypography>
    </Main>
    <Footer siteDef={siteDef} className='w-full pt-16 lg:mx-auto ' />
  </>)
}

export default Home
